import(/* webpackMode: "eager" */ "/codebuild/output/src3690189694/src/doctor-dashboard/app/global-error.tsx");
